<template>
    <div class="variableManage">
        <div class="con">
             <div class="left-tree">
                   <div class="search" style="margin-bottom:10px">
                     <el-input placeholder="输入关键字进行过滤" v-model="filterText"></el-input>
                 </div>
                 <div class="mytree" :style="{'height':heights+'px'}">
							<el-scrollbar style="height:calc(100% - 10px);width: 100%;">
							<el-tree :data="channelAndDeviceTree"   :expand-on-click-node="true" 
								:props="defaultProps" :highlight-current='true' show-checkbox ref="tree" @node-click="checkItem">
								<span class="custom-tree-node" slot-scope="{node, data}">
								<img src="../../../public/static/image/elTree/2.0.png" v-show="data.entityName=='Channel'"/>
								<img src="../../../public/static/image/elTree/2.0.png" v-show="!data.entityName"/>
								<img src="../../../public/static/image/elTree/2.1.png" v-show="data.entityName=='Device'"/>
								<span style="padding:0px  5px;">{{node.label }}</span>
								</span>
							</el-tree>
							</el-scrollbar>
					 </div>
             </div>
             <div class="right-table">
                  <div class="mytable">
                      <el-table id="demo" :height="heights" border v-loading="loading" stripe :data="tableData"  style="width: 100%">
                            <template slot="empty">
                            <span class="noData">
                                <img src="@/assets/noData.png" alt="暂无数据">
                                <span class="text">暂无数据</span>
                            </span>
                            </template>
                            <el-table-column label="序号" width="90" align="center">
                            <template slot-scope="scope">
                                <span>{{ scope.$index + 1 }}</span>
                            </template>
                            </el-table-column>
                            <el-table-column prop="name" label="点号" width="90" align="center"> </el-table-column>
                            <el-table-column prop="name" label="变量名称" min-width="230"> </el-table-column>
                            <el-table-column prop="name" label="变量全名" min-width="230"> </el-table-column>
                            <el-table-column prop="name" label="数据类型" width="90" align="center"> </el-table-column>
                            <el-table-column prop="name" label="访问" width="90" align="center"> </el-table-column>
                            <el-table-column prop="code" label="锁定" width="90" align="center"> </el-table-column>
                            <el-table-column prop="code" label="当前值" width="130" > </el-table-column>
                            <el-table-column prop="code" label="操作" width="180" align="center" fixed="right">
                                  <template #default="{row}">
                                    <div class="public-flex">
                                        {{row.name}}编辑
                                    </div>
                                </template>
                             </el-table-column>
                           
                         
                        </el-table>
                  </div>
             </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            heights: document.getElementById('app').clientHeight-170,
            channelAndDeviceTree: [],
            defaultProps: {
					children: 'next',
					label: 'name'
				},
            filterText:"",
            loading:false,
            tableData:[{}]
        };
    },

    mounted() {
        this.getChannelAndDeviceTree()
    },

    methods: {
        getChannelAndDeviceTree() {
			this.$api.deviceApi.getChannelAndDeviceTree(respon => {
				this.channelAndDeviceTree = [respon]
				// console.log("树形结构",this.channelAndDeviceTree);
			}, err => {
				this.$dialogMethod.showMessage(err)
			})
		},
        checkItem(){},
        
    },
};
</script>

<style lang="scss" scoped>
  .con {
    width: 100%;
    height: 100%;
    display: flex;
    .left-tree {
        width: 300px;
        height: 100%;
        background-color: #fff;
        padding: 12px;
        box-sizing: border-box;
        /deep/.el-tree {
            margin-top: -5px;
        }
    }
    .right-table {
        width: calc(100% - 308px);
        height: 100%;
        background-color: #fff;
        padding: 12px 20px;
        box-sizing: border-box;
        margin-left: 8px;
    }
  }
</style>